import { getFormValue } from '../utils'

export const prepareValuesForPreview = (eventType, formValues) => (
  eventType.isGroup
    ? { invitees_limit: getFormValue(eventType.invitees_limit, formValues.inviteesLimit, true) }
    : {}
)
